export default "__VITE_ASSET__e585c696__"